<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="应用名称" prop="name" :error="formErrorMsg.name">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="应用标识" prop="flag" :error="formErrorMsg.flag">
                <el-input v-model="formData.flag" ></el-input>
            </el-form-item>

            <el-form-item label="应用logo" prop="type">
                <input type="file" ref="appLogoFile"  @change="handlePhotoChange" style="display: none"></input>

                <div v-if="logoUrl" style="text-align: center;display: inline-block">
                    <img  @click="$refs.appLogoFile.click()"  :src="logoUrl" alt="" style="max-width: 200px;cursor: pointer;border: 1px solid #f0f0f0;"><br>
                </div>
                <div @click="$refs.appLogoFile.click()" v-else style="display: inline-block;width: 200px;line-height: 100px;border: 1px solid #f0f0f0;text-align: center;cursor: pointer">
                    请选择上传LOGO文件
                </div>
            </el-form-item>

            <el-form-item label="版权公司名称" prop="type">
                <el-input v-model="formData.company" ></el-input>

            </el-form-item>


            <el-form-item label="应用配置模板" prop="settingTpl" :error="formErrorMsg.settingTpl">
                <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.settingTpl">
                </el-input>
            </el-form-item>




            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import ModuleCascader from "../../components/ModuleCascader";
    export default {
        name: "RoleAdd",
        components: {ModuleCascader},
        data() {
            return {
                api:{
                   add:this.$api.app.add
                },
                logoUrl:'',
                formErrorMsg:{
                    name: '',
                    flag: '',
                    logoFile: '',
                    company: '',
                    settingTpl: '',
                },
                formData: {
                    name: '',
                    flag: '',
                    logoFile: '',
                    company: '',
                    settingTpl: '',

                },
                rules: {
                    name: [
                        {required: true, message: '请输入应用名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入应用标识', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handlePhotoChange(e){
                let vm = this;
                this.formData.logoFile = this.$refs['appLogoFile'].files[0];
                if(this.formData.logoFile){
                    let reader = new FileReader();
                    reader.readAsDataURL(this.formData.logoFile);
                    reader.onloadend = function (e) {
                        vm.logoUrl = e.target.result;
                    };

                }
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {


                        console.log(this.formData);

                        let formData = new FormData();

                        for(let key in this.formData){


                            if(this.formData[key]) formData.append(key, this.formData[key]);
                        }

                        vm.$http.post(vm.api.add,formData,{headers: { "Content-Type": "multipart/form-data" }}).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>